import api from './api-client';

export default (number) => api.get('/twilio/verify', { params: { number }});
